<template>
  <div class="c-header">
    <v-slide-y-transition appear>
      <v-img
        class="c-header__logo"
        src="@/assets/logo-nutrimix-distribuidora.svg"
        contain
        max-height="auto"
        max-width="190"
      />
    </v-slide-y-transition>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: {
    dadosUser: {},
  },
};
</script>

<style>
.c-header {
  grid-area: c-header;
  background: transparent;
  padding: 8px 25px;
  display: flex;
  align-items: center;
}
</style>
